import styled from 'styled-components';
import { COLORS } from '@themes';

type StyleProps = {
  $isDisplay: boolean;
};

export const CardStyle = styled.div.attrs((props) => ({}))<StyleProps>`
  transition: all 0.3s ease-out;
  opacity: ${({ $isDisplay }) => {
    return $isDisplay ? 1 : 0;
  }};
  .card {
    width: 100%;
    word-wrap: break-word;
    background-color: ${COLORS.BLACK_1};
    background-clip: border-box;
    border: 1px solid ${COLORS.BLACK_1};
    border-radius: 6px;
    cursor: pointer;
    box-sizing: border-box;
    &:hover {
      border: 1px solid ${COLORS.BLACK_2};
    }
  }
`;
